import { Form, Popup } from 'devextreme-react';
import { RequiredRule } from 'devextreme-react/data-grid';
import { ButtonItem, ButtonOptions, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/bulk-modal.scss';
import { useLoading } from '../../../contexts/loadingContext';
import { useTranslation } from '../../../contexts/translation';
import { CapacityCategory } from '../../../types/capacityCategory.types';
import { DataGridActionType } from '../../../types/dataGridActionTypes';
import { TaskStepStatus } from '../../../types/step.types';
import '../EditCreateModal.scss';
import '../TasksBulkEditModal.scss';

type Props = {
  data: any;
  isVisible: boolean;
  mutate?: () => void;
  onClose: () => void;
  onSubmit: (data: any, action: 'customStep' | 'step' | 'stepGroup') => void;
  actionType: DataGridActionType;
  capacityCategoryList?: CapacityCategory[];
  transFormName: string;
  title: string;
  popupWidth: string;
};

/**
 * Modalová komponent pro vytváření/editaci záznamů typu Task step
 */
export default function TaskCustomStepModal({
  data,
  isVisible,
  actionType,
  onClose,
  onSubmit,
  capacityCategoryList,
  transFormName,
  title,
  popupWidth,
}: Props) {
  const { translate } = useTranslation();
  const [stepStatusOptions, setStepStatusOptions] = useState<string[]>(
    Object.values(TaskStepStatus).map((key) => TaskStepStatus[key]),
  );
  const formRef = useRef<Form>(null);
  const { loading } = useLoading();
  const [formData, setFormData] = useState<any>({
    ...data,
    ...(actionType === DataGridActionType.Insert && { visible: true }),
  });

  useEffect(() => {
    setFormData({
      ...data,
      ...(actionType === DataGridActionType.Insert && { visible: true }),
      // asi překlep na BE capacityId místo capacityCategoryId, ale id správné
      capacityCategoryId: data?.capacityId,
      status: data?.status,
    });
  }, []);

  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick
      onHiding={onClose}
      showTitle
      title={translate!(title, transFormName)}
      width={popupWidth}
      height={'auto'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formData, 'customStep');
        }}
      >
        <Form
          formData={formData}
          showColonAfterLabel={true}
          showValidationSummary={true}
          ref={formRef}
        >
          <GroupItem>
            <SimpleItem
              dataField="capacityCategoryId"
              editorType="dxSelectBox"
              editorOptions={{
                items: capacityCategoryList,
                valueExpr: 'id',
                displayExpr: 'name',
              }}
            >
              <Label text={translate!('Capacity category', transFormName)} />
              <RequiredRule message={translate!('Select capacity category', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="name" editorType="dxTextArea">
              <Label text={translate!('Name', transFormName)} />
              <RequiredRule message={translate!('Select name', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="description" editorType="dxTextArea">
              <Label text={translate!('Description', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={4}>
            <GroupItem colSpan={2}></GroupItem>
            <ButtonItem>
              <ButtonOptions
                disabled={loading}
                type={'success'}
                text={translate!('Save', '')}
                useSubmitBehavior
              />
            </ButtonItem>
            <ButtonItem>
              <ButtonOptions type={'normal'} text={translate!('Close', '')} onClick={onClose} />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </Popup>
  );
}
